import {
  Box,
  Flex,
  Text,
  TextProps,
  useColorModeValue,
  useTheme,
} from "@chakra-ui/react";

export enum ScreenPositionEnum {
  TOP = "Top",
  BOTTOM = "Bottom",
}

export function Screen({
  screenPosition,
  screenTextProps,
}: {
  screenPosition: "Top" | "Bottom";
  screenTextProps?: TextProps;
}) {
  const theme = useTheme();
  const primaryColor = theme.colors.primary[500];

  const stopColorStart = useColorModeValue(
    `${primaryColor}CC`, // 80% opacity
    `${primaryColor}CC`,
  );
  const stopColorEnd = useColorModeValue(
    `${primaryColor}33`,
    `${primaryColor}33`,
  );
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      position="relative"
      mb={{
        base: 0,
        sm: 4,
      }}
      w={{
        base: "90%",
        md: "40%",
      }}
      // pt={screenPosition === "Top" ? "0px" : "20px"}
    >
      <Box
        as="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="26"
        fill={"Window"}
        viewBox="00 0 384 20"
        transform={
          screenPosition === ScreenPositionEnum.BOTTOM ? "rotate(180deg)" : ""
        }
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fill="url(#paint0_linear_3006_5824)"
          d="M1 25.036c149.238-29.389 232.878-29.374 382 0v80H1v-80z"
        />
        {/* <path
          stroke={primaryColor}
          strokeLinejoin="bevel"
          strokeWidth="1"
          d="M1 25.212c151.579-30.036 245.063-29.093 382 0"
        /> */}

        <defs>
          <linearGradient
            id="paint0_linear_3006_5824"
            x1="192"
            x2="192"
            y1="3"
            y2="105.036"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor={stopColorStart} />
            <stop offset="0.2" stopColor={stopColorEnd} />
          </linearGradient>
        </defs>
      </Box>

      <Text
        fontSize={{ base: "xs", md: "sm" }}
        color={"white"}
        position="absolute"
        top={"0.5"}
        fontWeight="medium"
        {...screenTextProps}
      >
        Cinema Screen Here
      </Text>
    </Flex>
  );
}
